const required_fields = [
   "title",
   "description",
   "category",
   "media_format"
]

export default required_fields